import { RoutePath } from '../constants/routePath.const';
import { UserRole } from '../constants/userRole.const';

export const USER_DEFAULT_REDIRECT: Partial<Record<UserRole, RoutePath>> = {
  [UserRole.NONE]: RoutePath.AUTH_SIGN_IN,
  [UserRole.USER]: RoutePath.ROOT_HOME,
  [UserRole.INITIAL]: RoutePath.AUTH_SIGN_UP,
  [UserRole.PARTIAL]: RoutePath.AUTH_SIGN_UP,
};
